/**
 * @author Shalini Jha
 * @name FooterComponent
 * @desc Composable footer component
 */
import React from 'react';
import styles from './Footer.module.css';
import { AppUtils } from '@gscope-mfe/app-bridge';

const FooterComponent = () => {
    const { children, message } = AppUtils.get().footerConfig;
    return (
        <div className={styles.footerContainer}>
            {message}
            {children}
        </div>
    );
};

export default FooterComponent;
